export const KNOWLEDGE_BASES_SELF_ENDPOINT = '/p/v3/kb/knowledge-bases/self';
